module.exports = __webpack_public_path__ + "static/media/icon-simple-check.4db4903c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/icon-simple-check.svg
// module id = 1246
// module chunks = 19